import { useContext, useState } from "react";
import { AuthContext } from "../context/AuthProvider";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";
import SocialHanldes from "./SocialHandles";
import "../index.css";

const Navbar = ({homeCSS}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { user } = useContext(AuthContext);
  const toggleMenu = () => setIsOpen(!isOpen);
  let checkUser = [
    { name: "Login", url: "/login" },
    { name: "Sign up", url: "/sign-up" },
  ];
  if (user) {
    checkUser = [
      { name: "Profile", url: "/user/my-profile" },
      { name: "Dashboard", url: user.isAdmin ? "/admin" : "/user/my-dashboard" },
    ];
  }
  const navLinks = [{ name: "Home", url: "/" },{ name: "About", url: "/about" }, { name: "Pricing", url: "/plans" }, ...checkUser].map((link) => {
    return (
      <li key={link.name}>
        <Link to={link.url} className={`text-xl hover:text-yellow-600 ${link.name==="Sign up"?"text-red-500":"text-white/80 "}`}>
          {link.name}
        </Link>
      </li>
    );
  });
  return (
    <>
      {/* Navbar for Large Screens */}
      <nav className={`hidden w-full md:flex md:justify-between items-center px-6 py-2 bg-gray-800 shadow-md ${homeCSS && homeCSS}`}>
        <h1 className="text-4xl font-bold text-yellow-400">Bliss Distro</h1>
        <ul className="flex space-x-6">{navLinks}</ul>
      </nav>

      {/* Mobile Navbar */}
      <nav className={`md:hidden flex justify-between items-center px-4 py-3 bg-gray-900 text-white ${homeCSS} shadow-md w-full`}>
        <h1 className={`${homeCSS? "text-2xl":"text-xl"} font-bold text-yellow-400`}>Bliss Distro</h1>
        <button onClick={toggleMenu}>
          {!isOpen ? (
            <FontAwesomeIcon icon={faBars} size="2x" />
          ) : (
            <FontAwesomeIcon icon={faBars} size="2x" />
          )}
        </button>
      </nav>

      {/* Sidebar (Mobile) */}
      {isOpen && (
        <motion.div
          initial={{ x: "-100%" }}
          animate={{ x: 0 }}
          exit={{ x: "-100%" }}
          transition={{ duration: 0.3 }}
          className="fixed top-0 left-0 w-64 h-full bg-gray-800 text-white shadow-lg z-50 flex flex-col p-6"
        >
          <button className="self-end mb-2 z-10" onClick={toggleMenu}>
            {" "}
            <FontAwesomeIcon
              className="hover:text-red-400"
              icon={faTimes}
              size="2x"
            />
          </button>
          <h1 className="text-2xl font-bold -mt-10 w-50 pb-4 text-yellow-400">Bliss Distro</h1>
          <ul className="flex flex-col space-y-4" onClick={toggleMenu}>
            {navLinks}
          </ul>
          <div className="absolute bottom-4 left-2 flex pr-5 pl-2 w-full justify-between"><SocialHanldes/></div>
        </motion.div>
      )}
    </>
  );
};

export default Navbar;
